(() => {
  const root = document.querySelector('section[itemtype="https://schema.org/FAQPage"]');
  if (!root) return;

  const blocks = root.querySelectorAll('[itemtype="https://schema.org/Question"]');

  blocks.forEach((block, idx) => {
    const h2 = block.querySelector('h2[itemprop="name"].faq-q');
    const answerWrap = block.querySelector('.faq-a');
    const inner = block.querySelector('.faq-a-inner');
    if (!h2 || !answerWrap || !inner) return;

    h2.setAttribute('role','button');
    h2.setAttribute('tabindex','0');
    h2.setAttribute('aria-controls', 'faq-a-' + idx);
    h2.setAttribute('aria-expanded', idx === 0 ? 'true' : 'false');
    answerWrap.id = 'faq-a-' + idx;

    const setOpen = (open) => {
      h2.setAttribute('aria-expanded', open ? 'true' : 'false');
      answerWrap.style.maxHeight = open ? (inner.scrollHeight + 24) + 'px' : 0;
    };

    setOpen(idx === 0);

    const toggle = () => setOpen(h2.getAttribute('aria-expanded') !== 'true');
    h2.addEventListener('click', toggle);
    h2.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });

  window.addEventListener('resize', () => {
    root.querySelectorAll('.faq-q[aria-expanded="true"]').forEach(h2 => {
      const aw = document.getElementById(h2.getAttribute('aria-controls'));
      const inner = aw ? aw.querySelector('.faq-a-inner') : null;
      if (aw && inner) aw.style.maxHeight = (inner.scrollHeight + 24) + 'px';
    });
  });
})();
